<template>
  <div v-if="params">
    <div v-if="params.data">
      <span v-if="params.value || params.value === 0" style="letter-spacing: -0.25em;">
        <font-awesome-icon  v-for="(item, index) in this.getItems()" 
                            :key="item" 
                            :icon="getIcon(index, params.value)" />
      </span>
      
      <TrendIcon v-if="params.value || params.value === 0" :Difference="this.trend" class="ml-2"/>
      
      {{ params.value || params.value === 0 ? params.value.toFixed(1) : params.value }}
      
      <div>
        <AccomplishmentIcon v-if="hasAccomplished()" 
                            :isAccomplished="isAccomplished()" />
      </div>
    </div>

    <div v-if="(params.value || params.value === 0) && this.rowProperty && this.rowProperty.max">
      <div class="d-flex justify-content-between">
        <div>
          {{this.rowProperty.min}}
          <font-awesome-icon :icon="['fal', 'ellipsis-h']"/>
          {{this.rowProperty.max}}
        </div>
        <div v-if="this.rowProperty.avg">
          ∅ {{ this.rowProperty.avg }}
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";
import CellRendererMixin from '@/mixins/jlr/CellRendererMixin';
import TrendIcon from "@/components/Shared/TrendIcon";

export default {
  mixins: [
    CellRendererMixin
  ],
  components: {
    AccomplishmentIcon, TrendIcon
  },
  methods: {
    getIcon(index, val) {
      if (val < index + 0.25)
        return ['far', 'star'];
      else if (val > index + 0.75)
        return ['fas', 'star'];
      else  {
        return ['fas', 'star-half-alt'];
      }
    },
    getItems() {
      return [ 0, 1, 2, 3, 4 ];
    }
  }
}
</script>
